const locale = {
  prelaunch: {
    title: 'Trova un dottore vicino a te in modo semplice',
    subtitle:
      'Evita lunghe attese, contatta un dottore in pochi secondi, fissa un appuntamento.',
    beta_welcome_disclaimer:
      "Siamo attualmente in beta! Nel frattempo puoi scoprire tutte le novità sull'app nel nostro <0><0>canale Discord</0></0>, dove si scambiano idee e i sogni prendono il volo!",
    enter_email: 'Inserisci la tua email',
    accept_disclaimer:
      "Ho letto e accetto l'<0><0>Informativa Privacy</0></0> e i <1><0>Termini di Utilizzo</0></1>",
    accept_disclaimer_label:
      "Ho letto e accetto l'Informativa Privacy e i Termini di Utilizzo",
    early_access_button: 'Ricevi un invito anticipato',
    beta_disclaimer:
      'Siamo attualmente in beta! Iscriviti per ricevere un invito',
    success_title: 'Grazie! Sei grande!',
    success_first_text:
      "Grazie ancora per il tuo interesse in <0>{{name}}</0>! Appena l'app uscirà dalla beta con i primi utenti e sarà pronta per il lancio ufficiale, ti manderemo un email per avvertirti!",
    success_second_text:
      "Nel frattempo puoi scoprire tutte le novità sull'app nel nostro <0><0>canale Discord</0></0>, dove si scambiano idee e i sogni prendono il volo!",
    already_account: 'Hai già un account? <0><0>Accedi</0></0>',
  },
  beta: {
    wip_page_message:
      'Questa funzione è attualmente in via di sviluppo. Nel frattempo se hai bisogno di aiuto puoi contattarci nel nostro <0><0>canale Discord!</0></0>',
  },
  footer: {
    all_rights_reserved: 'Tutti i diritti riservati',
    privacy_policy: 'Informativa Privacy',
    terms_of_service: 'Termini di Utilizzo',
    cookie_policy: 'Cookie e Preferenze',
    company_info:
      '{{service_name}} © {{start_year}} - {{current_year}} {{company_name}}, {{company_address}}. C.F. {{company_cf}} P.IVA {{company_vat}}',
  },
  header: {
    anywhere_label: 'Ovunque',
    anyday_label: 'Qualsiasi Giorno',
    selected_area_label: 'Area Selezionata',
  },
  meta: {
    partner_page_title_tail: 'Prenota un appuntamento',
  },
  navbar: {
    join_team: 'Aggiungimi alla lista',
    usermenu_dashboard_label: 'Dashboard',
    usermenu_home_label: 'Cerca',
    usermenu_login_label: 'Accedi',
    usermenu_signup_label: 'Crea account',
    usermenu_logout_label: 'Esci',
    usermenu_account_label: 'Account',
    usermenu_appointments_label: 'Appuntamenti',
    usermenu_messages_label: 'Messaggi',
    usermenu_services_label: 'Servizi',
    usermenu_venues_label: 'Sedi',
    usermenu_profile_label: 'Profilo',
  },
  register: {
    modal_title: 'Crea account',
    modal_header_title: 'Benvenuto su {{name}}',
    modal_header_subtitle: 'Crea un account',
    modal_submit_btn_label: 'Continua',
    modal_google_btn_label: 'Continua con Google',
    modal_input_firstname_label: 'Nome',
    modal_input_lastname_label: 'Cognome',
    modal_input_email_label: 'Email',
    modal_input_phone_label: 'Telefono',
    modal_input_password_label: 'Password',
    modal_input_confirm_password_label: 'Conferma Password',
    modal_login_text: 'Hai già un account?',
    modal_login_label: 'Accedi',
    modal_beta_disclaimer: 'Mah',
    validation_error_first_name_required: 'Nome richiesto',
    validation_error_first_name_long: 'Nome troppo lungo',
    validation_error_first_name_short: 'Nome troppo corto',
    validation_error_last_name_required: 'Cognome richiesto',
    validation_error_last_name_long: 'Cognome troppo lungo',
    validation_error_last_name_short: 'Cognome troppo corto',
    validation_error_email_required: 'Email richiesta',
    validation_error_email_invalid: 'Email non valida',
    validation_error_password_required: 'Password richiesta',
    validation_error_password_short: 'Minimo 6 caratteri',
    validation_error_password_long: 'Massimo 40 caratteri',
    validation_error_confirm_password_required:
      'Password di conferma richiesta',
    validation_error_confirm_password_short: 'Minimo 6 caratteri',
    validation_error_confirm_password_long: 'Massimo 40 caratteri',
    validation_error_confirm_password_mismatch: 'Password diverse',
    notification_account_created: 'Account creato!',
    notification_cannot_create_account: 'Impossibile creare account',
  },
  forgot: {
    modal_title: 'Ripristina password',
    modal_header_title: 'Ripristina la tua password',
    modal_header_subtitle: 'Inserisci il tuo indirizzo email',
    modal_input_email_label: 'Email',
    modal_submit_btn_label: 'Ripristina',
    modal_register_text: 'Prima volta su {{name}}?',
    modal_register_label: 'Crea account',
    validation_error_email_required: 'Email richiesta',
    validation_error_email_invalid: 'Email non valida',
    notification_email_sent: 'Email inviata!',
    notification_cannot_reset: 'Impossibile ripristinare password',
  },
  reset: {
    modal_title: 'Ripristina password',
    modal_header_title: 'Ripristina la tua password',
    modal_header_subtitle: 'Inserisci la tua nuova password',
    modal_input_password_label: 'Nuova Password',
    modal_input_confirm_password_label: 'Conferma Nuova Password',
    modal_submit_btn_label: 'Ripristina',
    modal_register_text: 'Prima volta su {{name}}?',
    modal_register_label: 'Crea account',
    notification_code_not_found: 'codice di reset non trovato',
    notification_reset_success: 'Password aggiornata!',
    notification_reset_failure: 'Non posso aggiornare la password',
    validation_error_password_required: 'Password richiesta',
    validation_error_password_short: 'Minimo 6 caratteri',
    validation_error_password_long: 'Massimo 40 caratteri',
    validation_error_confirm_password_required:
      'Password di conferma richiesta',
    validation_error_confirm_password_short: 'Minimo 6 caratteri',
    validation_error_confirm_password_long: 'Massimo 40 caratteri',
    validation_error_confirm_password_mismatch: 'Password diverse',
  },
  search: {
    modal_title: 'Cerca',
    modal_submit_btn_label: 'Cerca',
  },
  confirm: {
    notification_code_not_found: 'codice di conferma non trovato',
    notification_code_not_valid: 'codice di conferma non valido',
    notification_success: 'Account confermato!',
  },
  login: {
    modal_title: 'Accedi',
    modal_header_title: 'Ciao!',
    modal_header_subtitle: 'Accedi al tuo account',
    modal_input_email_label: 'Email',
    modal_input_password_label: 'Password',
    modal_submit_btn_label: 'Continua',
    modal_register_text: 'Prima volta su {{name}}?',
    modal_register_label: 'Crea account',
    modal_forgot_text: 'Password dimenticata?',
    modal_google_btn_label: 'Continua con Google',
    validation_error_email_required: 'Email richiesta',
    validation_error_email_invalid: 'Email non valida',
    validation_error_password_required: 'Password richiesta',
    validation_error_password_short: 'Minimo 6 caratteri',
    validation_error_password_long: 'Massimo 40 caratteri',
    notification_cannot_login: 'Email o password non valide',
  },
  join: {
    modal_title: 'Aggiungimi alla lista',
    modal_submit_btn_label: 'Invia',
    modal_create_btn_label: 'Crea',
    modal_success_btn_label: 'Continua',
    modal_next_btn_label: 'Avanti',
    modal_back_btn_label: 'Indietro',
    modal_step_categories_heading_title:
      'Quale descrive meglio la tua esperienza?',
    modal_step_categories_heading_subtitle: 'Scegli una categoria',
    modal_step_location_heading_title: 'Dove svolgi la tua attività?',
    modal_step_location_heading_subtitle: 'Aiuta gli altri a trovarti!',
    modal_step_location_select_country_placeholder: 'Seleziona una nazione',
    modal_step_location_select_state_placeholder:
      'Seleziona un paese / regione',
    modal_step_location_select_city_placeholder: 'Seleziona una città',
    modal_step_location_no_countries_label: 'Nessun risultato',
    modal_step_location_no_cities_label: 'Nessun risultato',
    modal_step_location_enter_address_label: "Inserisci l'indirizzo",
    modal_step_location_tip_text:
      'Se non riusciamo a trovare il tuo indirizzo o la posizione non è accurata puoi cliccare sulla mappa per positionare il marker sulla posizione esatta',
    modal_step_hours_heading_title: "Qual'è il tuo orario di lavoro?",
    modal_step_hours_heading_subtitle:
      'Per sapere quando è possibile prenotare un appuntamento con te!',
    modal_step_hours_closed_label: 'Chiuso',
    modal_step_service_heading_title: 'Di che ti occupi?',
    modal_step_service_heading_subtitle: 'Descrivi uno dei servizi che offri',
    modal_step_service_label_name: 'Nome servizio',
    modal_step_service_label_description: 'Descrizione servizio',
    modal_step_service_label_duration: 'Durata (minuti)',
    modal_step_service_label_price: 'Prezzo',
    modal_step_service_placeholder_name: 'Primo appuntamento',
    modal_step_service_placeholder_description:
      'Il primo passo per una vita più sana',
    validation_step_location_error_address_required: 'Indirizzo richiesto',
    validation_step_service_error_name_required: 'Nome richiesto',
    validation_step_service_error_name_short: 'Nome troppo corto',
    validation_step_service_error_name_long: 'Nome troppo lungo',
    validation_step_service_error_description_required: 'Descrizione richiesta',
    validation_step_service_error_description_short: 'Descrizione troppo corta',
    validation_step_service_error_description_long: 'Descrizione troppo lunga',
    validation_step_service_error_duration_required: 'Durata richiesta',
    validation_step_service_error_duration_number:
      'La durata deve essere un numero',
    validation_step_service_error_duration_minimum:
      'La durata minima è {minutes} minuti',
    validation_step_service_error_price_required: 'Prezzo richiesto',
    validation_step_service_error_price_number:
      'Il prezzo deve essere un numero',
    validation_step_service_error_price_positive: 'Prezzo non valido',
    modal_step_photo_heading_title: 'Aggiungi foto profilo',
    modal_step_photo_heading_subtitle:
      'Segui il nostro esempio per aumentare le visualizzazioni',
    modal_step_photo_droplet_label:
      'Trascina un immagine o Clicca per caricare',
    modal_step_photo_notification_image_small: 'Immagine troppo piccola',
    modal_step_success_summary_line_a: 'Evviva!',
    modal_step_success_summary_line_b:
      'Grazie per sostenerci nel far crescere la nostra rete di persone eccezionali!',
    modal_step_success_summary_line_c_pending:
      'Il nostro team valuterà la tua richiesta nel più breve tempo possibile e riceverai una nostra email una volta che la revisione è stata completata.',
    modal_step_success_summary_line_c_approved:
      'Ti diamo il benvenuto su {{name}}. Ti consigliamo di completare tutti i dati del tuo profilo pubblico. Più dettagli abbiamo, più possiamo aiutare te e le altre persone a trovarti.',
  },
  profile_page: {
    biography_section_label: 'Biografia',
    total_reviews_summary: '{{amount}} recensioni',
    show_all_reviews_btn_label: 'Mostra tutte le {{amount}} recensioni',
    available_appointments_header: 'Orari disponibili',
    available_services_empty_label: 'Nessun servizio disponibile',
    available_appointments_empty_label: 'Nessun orario disponibile',
    available_services_header: 'Servizi',
    service_duration_label: '{{duration}} minuti',
    summary_total_reviews_label: '{{amount}} recensioni',
    edit_profile: 'Modifica profilo',
    edit_venues: 'Modifica sedi',
    edit_services: 'Modifica servizi',
    edit_hours: 'Modifica disponibilità',
    edit_bio: 'Modifica biografia',
    no_bio: 'Nessuna biografia',
    notification_update_title_success_message: 'Profilo aggiornato',
    notification_update_title_failure_message: 'Impossibile aggiornare profilo',
    gender_1: 'Dott.',
    gender_2: 'Dott.ssa',
    gender_3: 'Dott.',
    api_error_cannot_create_appointment_message:
      'Impossibile creare appuntamento',
  },
  not_found_page: {
    not_found_title: 'Questa pagina non esiste',
    not_found_message: 'Scusa ma questa pagina non esiste',
    go_home_button_label: 'Questa si',
  },
  hours: {
    closed_label: 'Chiuso',
  },
  cookie_banner: {
    banner_title: 'Cookies',
    banner_text:
      '<0>Crediamo che i tuoi dati siano di tua proprietà e sosteniamo il tuo diritto alla privacy e alla trasparenza.</0> Utilizziamo i cookie per migliorare la tua esperienza di navigazione, fornire annunci personalizzati o consenso e analizzare il nostro traffico. Cliccando <1>Accetta</1> acconsenti al nostro utilizzo dei cookie. Leggi di più sulla nostra <2>Politica Cookie</2> e <3>Informativa Privacy</3>.',
    banner_btn_customize_label: 'Personalizza',
    banner_btn_confirm_choices_label: 'Conferma le mie scelte',
    banner_btn_reject_label: 'Solo cookies necessari',
    banner_btn_accept_all_label: 'Accetta',
  },
  cart: {
    appointment_service_name_label: 'Servizio',
    appointment_service_address_label: 'Presso',
    appointment_service_time_label: 'Appuntamento',
    appointment_action_button_label: 'Prenota appuntamento',
    appointment_action_button_short_label: 'Prenota',
    no_slots_available_main: 'Nessun orario disponibile',
    change_time_main: 'Cambia periodo selezionato',
    change_business_main: 'Cambia luogo selezionato',
    no_payment_required: 'Senza obbligo, nessun pagamento richiesto',
    no_slots_available_description:
      'Il professionista non è disponibile al momento, prova a cambiare il periodo o il luogo selezionato per trovare disponibilità',
    no_slots_available_mobile_description:
      'Il professionista non è disponibile al momento, clicca per cambiare periodo e trovare disponibilità',
  },
  available_appointments: {
    modal_title: 'Orari disponibili',
    modal_submit_btn_label: 'Continua',
    modal_confirm_btn_label: 'Conferma',
    modal_cancel_btn_label: 'Indietro',
    modal_change_business_btn_label: 'Cambia luogo selezionato',
  },
  available_businesses: {
    modal_title: 'Sedi disponibili',
    modal_submit_btn_label: 'Continua',
    modal_no_business_available: 'Nessun luogo disponibile',
  },
  available_services: {
    modal_title: 'Servizi disponibili',
    modal_submit_btn_label: 'Continua',
  },
  reviews: {
    modal_title: 'Recensioni',
    modal_submit_btn_label: 'Continua',
  },
  review_details: {
    modal_title: 'Recensione',
    modal_submit_btn_label: 'Chiudi',
  },
  chat_user_details: {
    modal_submit_btn_label: 'Chiudi',
  },
  contact_confirmation: {
    modal_title: 'Conferma',
    modal_submit_btn_label: 'Prenota',
    notes_placeholder: 'Note',
    notes_default_value: 'Salve,\nvorrei prenotare un appuntamento',
    validation_notes_long: 'Messaggio troppo lungo',
  },
  upload_profile_picture: {
    modal_title: 'Carica immagine profilo',
    modal_submit_btn_label: 'Carica',
    modal_next_btn_label: 'Avanti',
    modal_back_btn_label: 'Indietro',
    modal_cancel_btn_label: 'Annulla',
    api_upload_failure: 'Impossibile aggiornare',
    api_upload_success: 'Immagine profilo aggiornata',
    api_delete_failure: 'Impossibile cancellare',
    api_delete_success: 'Immagine profilo cancellata',
  },
  delete_account: {
    modal_title: 'Cancella account',
    modal_submit_btn_label: 'Cancella',
    modal_cancel_btn_label: 'Annulla',
    modal_disclaimer_text:
      "Cancellando il tuo account rimuovi tutte tue informazioni dal nostro database. L'operazione non può essere annullata.",
    modal_delete_text: 'Per confermare, inserisci la tua password',
    validation_error_password_required: 'Password richiesta',
    validation_error_password_short: 'Minimo 6 caratteri',
    validation_error_password_long: 'Massimo 40 caratteri',
    api_error_cannot_delete_message: 'Impossibile cancellare account',
    api_error_password_wrong_message: 'Password errata',
  },
  change_password: {
    modal_title: 'Modifica password',
    modal_submit_btn_label: 'Salva',
    modal_cancel_btn_label: 'Annulla',
    api_error_cannot_delete_message: 'Impossibile aggiornare la password',
    api_error_password_wrong_message: 'La password attuale è errata',
    validation_error_password_required: 'Password richiesta',
    validation_error_password_short: 'Minimo 6 caratteri',
    validation_error_password_long: 'Massimo 40 caratteri',
    validation_error_confirm_password_required:
      'Password di conferma richiesta',
    validation_error_confirm_password_short: 'Minimo 6 caratteri',
    validation_error_confirm_password_long: 'Massimo 40 caratteri',
    validation_error_confirm_password_mismatch: 'Password diverse',
    validation_error_confirm_password_different:
      'La nuova password deve essere diversa',
    modal_header_title: 'Aggiorna password',
    modal_header_subtitle: 'Cambia la tua password attuale',
    modal_input_new_password_label: 'Inserisci la nuova password',
    modal_input_confirm_new_password_label: 'Confirma la nuova password',
  },
  contact_details: {},
  new_appointment: {
    modal_title: 'Nuovo Appuntamento',
    modal_submit_btn_label: 'Continua',
    modal_create_btn_label: 'Crea appuntamento',
    modal_success_btn_label: 'Chiudi',
    modal_back_btn_label: 'Indietro',
    modal_step_service_heading_title: 'Seleziona un servizio',
    modal_step_service_heading_subtitle:
      'Quale servizio per il nuovo appuntamento?',
    modal_step_time_heading_title: 'Seleziona un orario',
    modal_step_time_heading_subtitle:
      'Per quando vuoi fissare il nuovo appuntamento?',
    modal_step_specific_time_heading_title: 'Seleziona un periodo specifico',
    modal_step_specific_time_heading_subtitle:
      'Per quando vuoi fissare il nuovo appuntamento?',
    modal_step_force_time_heading_title: 'Seleziona giorno',
    modal_step_force_time_warning_free_limit:
      'Potresti aver raggiunto il limite degli appuntamenti per il mese selezionato. Passa al Piano Unlimited per creare appuntamenti illimitati',
    modal_step_new_contact_warning_free_limit:
      'Hai raggiunto il limite dei contatti per il tuo piano di abbonamento. Passa al Piano Unlimited per avere contatti illimitati',
    modal_step_force_time_heading_subtitle:
      'Per quando vuoi fissare il nuovo appuntamento?',
    modal_step_force_hour_heading_title: 'Seleziona orario',
    modal_step_force_business_heading_title: 'Seleziona luogo',
    modal_step_specific_hour_heading_title: 'Seleziona un orario specifico',
    modal_step_specific_hour_heading_subtitle:
      'Per quando vuoi fissare il nuovo appuntamento?',
    modal_step_contact_heading_title: 'Seleziona contatto',
    modal_step_contact_heading_subtitle:
      'Per chi stai fissando il nuovo appuntamento?',
    modal_step_new_contact_heading_title: 'Nuovo contatto',
    modal_step_new_contact_heading_subtitle:
      'Per chi stai fissando il nuovo appuntamento?',
    modal_step_summary_heading_title: 'Conferma nuovo appuntamento',
    modal_step_summary_heading_subtitle:
      'Controlla che i dati siano corretti prima di crearlo',
    modal_step_success_heading_title: 'Appuntamento creato con successo!',
    modal_step_success_heading_subtitle:
      "Condividi i dettagli dell'appuntamento",
    service_duration_label: '{{duration}} minuti',
    contact_search_input_label: 'Cerca',
    no_contact_found_label: 'Nessun contatto trovato',
    new_contact_input_first_name_label: 'Nome',
    new_contact_input_last_name_label: 'Cognome',
    new_contact_input_email_label: 'Email (opzionale)',
    new_contact_input_phone_label: 'Telefono (opzionale)',
    validation_error_new_contact_first_name_required: 'Nome richiesto',
    validation_error_new_contact_first_name_long: 'Nome troppo lungo',
    validation_error_new_contact_first_name_short: 'Nome troppo corto',
    validation_error_new_contact_last_name_required: 'Cognome richiesto',
    validation_error_new_contact_last_name_long: 'Cognome troppo lungo',
    validation_error_new_contact_last_name_short: 'Cognome troppo corto',
    validation_error_new_contact_email_invalid: 'Email non valida',
    validation_error_new_contact_phone_invalid: 'Numero di telefono non valido',
    notification_success_message: 'Appuntamento creato con successo',
    notification_failure_message: 'Errore creazione appuntamento',
    modal_step_specific_time_button_label: 'Seleziona un periodo specifico',
    notes_placeholder: "Aggiungi note sull'appuntamento",
    validation_notes_long: 'Messaggio troppo lungo',
    force_hour_button_label: 'Aggiungi comunque',
    specify_time_button_label: 'Altro orario',
    new_contact_checkbox_gdpr_label: 'Consenso al trattamento dei dati',
    new_contact_checkbox_marketing_label: 'Consenso comunicazioni e promozioni',
    button_label_send_whatsapp_notification: 'Invia conferma via WhatsApp',
    button_label_send_sms_notification: 'Invia conferma via SMS',
    confirm_send_whatsapp_reminder_disclaimer_text:
      'Inviare conferma via WhatsApp a {{name}}?',
    confirm_send_whatsapp_reminder_disclaimer_cancel_label: 'Cancella',
    confirm_send_whatsapp_reminder_disclaimer_confirm_label: 'Invia',
    confirm_send_sms_reminder_disclaimer_text:
      'Inviare conferma via SMS a {{name}}?',
    confirm_send_sms_reminder_disclaimer_cancel_label: 'Annulla',
    confirm_send_sms_reminder_disclaimer_confirm_label: 'Invia',
    confirm_add_contact_phone_disclaimer_text:
      'Questo contatto non ha un numero di telefono. Vuoi aggiungerlo?',
    confirm_add_contact_phone_disclaimer_cancel_label: 'Annulla',
    confirm_add_contact_phone_disclaimer_confirm_label: 'Aggiungi numero',
  },
  move_appointment: {
    modal_title: 'Sposta Appuntamento',
    modal_success_btn_label: 'Chiudi',
    modal_create_btn_label: 'Sposta',
    modal_submit_btn_label: 'Continua',
    modal_back_btn_label: 'Indietro',
    notification_success_message: 'Appuntamento spostato con successo',
    notification_failure_message: 'Impossibile spostare appuntamento',
    modal_step_summary_heading_title: 'Conferma sposta appuntamento',
    modal_step_summary_heading_subtitle:
      'Controlla che i dati siano corretti prima di spostarlo',
    modal_step_success_heading_title: 'Appuntamento spostato con successo!',
    modal_step_success_heading_subtitle:
      "Condividi i dettagli dell'appuntamento",
    modal_step_time_heading_title: 'Seleziona un orario',
    modal_step_time_heading_subtitle: "A quando vuoi spostare l'appuntamento?",
    modal_step_specific_time_heading_title: 'Seleziona un periodo specifico',
    modal_step_specific_time_heading_subtitle:
      "A quando vuoi spostare l'appuntamento?",
    button_label_send_whatsapp_notification: 'Invia conferma via WhatsApp',
    button_label_send_sms_notification: 'Invia conferma via SMS',
    confirm_send_whatsapp_reminder_disclaimer_text:
      'Inviare conferma via WhatsApp a {{name}}?',
    confirm_send_whatsapp_reminder_disclaimer_cancel_label: 'Cancella',
    confirm_send_whatsapp_reminder_disclaimer_confirm_label: 'Invia',
    confirm_send_sms_reminder_disclaimer_text:
      'Inviare conferma via SMS a {{name}}?',
    confirm_send_sms_reminder_disclaimer_cancel_label: 'Annulla',
    confirm_send_sms_reminder_disclaimer_confirm_label: 'Invia',
    confirm_add_contact_phone_disclaimer_text:
      'Questo contatto non ha un numero di telefono. Vuoi aggiungerlo?',
    confirm_add_contact_phone_disclaimer_cancel_label: 'Annulla',
    confirm_add_contact_phone_disclaimer_confirm_label: 'Aggiungi numero',
  },
  cancel_appointment: {
    modal_title: 'Cancella Appuntamento',
    modal_step_cancel_appointment_heading_title:
      'Seleziona il motivo della cancellazione',
    modal_step_cancel_appointment_heading_subtitle:
      "Seleziona l'opzione corretta",
    modal_submit_btn_label: 'Cancella Appuntamento',
    modal_back_btn_label: 'Indietro',
    modal_step_cancel_appointment_notes_placeholder: 'Aggiungi note',
    'modal_step_cancel_appointment_option_dc138457-ffc3-41c7-a07a-276c9c2b4df7':
      "Il paziente ha richiesto di cancellare l'appuntamento",
    'modal_step_cancel_appointment_option_8b7bb270-1e52-4be3-8623-befc564cd7bb':
      'Il paziente non si è presentato',
    'modal_step_cancel_appointment_option_dba1450b-a4bf-4753-8921-77c60ec085be':
      'Aggiunto per errore dal paziente',
    'modal_step_cancel_appointment_option_1f2b387c-28b0-49ab-b2b4-65a6e715df02':
      'Altro',
    'modal_step_cancel_appointment_option_d9c61337-b226-47f5-9457-c41dd7c3c3b6':
      'Non storicizzare',
  },
  new_contact: {
    modal_title: 'Nuovo Contatto',
    modal_submit_btn_label: 'Crea',
    modal_step_new_contact_heading_title: 'Nuovo Contatto',
    modal_step_new_contact_heading_subtitle:
      'Inserisci i dati del nuovo contatto',
    notification_success_message: 'Contatto creato con successo',
    notification_failure_message: 'Impossibile creare contatto',
  },
  edit_biography: {
    modal_title: 'Modifica biografia',
    modal_submit_btn_label: 'Salva',
    modal_heading_title: 'Biografia',
    modal_heading_subtitle: 'Inserisci una descrizione della tua biografia',
    notification_success_message: 'Biografia aggiornata con successo',
    notification_failure_message: 'Impossibile aggiornare biografia',
    biography_placeholder: 'Inserisci una descrizione della tua biografia',
    validation_biography_long: 'Biografia troppo lunga',
  },
  generic: {
    closed: 'Chiuso',
    back: 'Indietro',
    functionality_in_progress: 'Questa funzionalità verrà rilasciata a breve',
    weekday_monday: 'Lunedì',
    weekday_tuesday: 'Martedì',
    weekday_wednesday: 'Mercoledì',
    weekday_thursday: 'Giovedì',
    weekday_friday: 'Venerdì',
    weekday_saturday: 'Sabato',
    weekday_sunday: 'Domenica',
    weekday_1: 'Lunedì',
    weekday_2: 'Martedì',
    weekday_3: 'Mercoledì',
    weekday_4: 'Giovedì',
    weekday_5: 'Venerdì',
    weekday_6: 'Sabato',
    weekday_7: 'Domenica',
    expert_in: 'Esperto in',
    next_available: 'Disponibile da',
    not_available: 'Attualmente non disponibile',
    show_all: 'Mostra tutto',
    hide_all: 'Mostra meno',
    show_more_options: 'Mostra più orari',
    show_more_services: 'Mostra tutti i servizi',
    hide_more_services: 'Mostra meno',
    show_more_businesses: 'Mostra più sedi',
    show_no_businesses: 'Nessun luogo',
    share_button_label: 'Condividi',
    save_button_label: 'Salva',
    show_map: 'Mostra mappa',
    show_map_short: 'Mappa',
    show_list: 'Mostra lista',
    show_list_short: 'Lista',
    no_results: 'Nessun risultato trovato',
    no_hours_available: 'Nessun orario disponibile',
    address_not_found: 'Indirizzo non trovato',
    contact_not_found: 'Contatto non trovato',
    treatment_not_found: 'Trattamento non trovato',
    edit_label: 'Modifica',
    selector_placeholder: 'Seleziona...',
    today: 'Oggi',
    yesterday: 'Ieri',
    tomorrow: 'Domani',
    this_week_day: '{{name}}',
    gender_1: 'Dott.',
    gender_2: 'Dott.ssa',
    gender_3: 'Dott.',
    and: ' e ',
    in_city: 'a {{city}}',
    account_tier_name_0: 'Sconosciuto',
    account_tier_name_1: 'Free',
    account_tier_name_2: 'Pro',
    account_tier_name_3: 'Unlimited',
  },
  logo: {
    account_tier_name_0: 'Piano Sconosciuto',
    account_tier_name_1: 'Piano Free',
    account_tier_name_2: 'Piano Pro',
    account_tier_name_3: 'Piano Unlimited',
  },
  prices: {
    unexpected_error_label:
      'Non è possibile aggiornare il piano in questo momento',
    most_popular_label: 'Il più popolare',
    payment_period_selector_yearly_label: 'Annuale',
    payment_period_selector_yearly_discount_label: '-20%',
    payment_period_selector_monthly_label: 'Mensile',
    paid_suffix: ' /mese',
    free_suffix: 'per sempre',
    purchase_plan_btn_label: 'Acquista Piano',
    start_free_trial_btn_label: 'Inizia la prova gratuita',
    sign_up_btn_label: 'Iscriviti, è gratis!',
    upgrade_btn_label: 'Passa a {{tier_name}}',
    included_label: 'Incluso',
    your_plan_label: 'Il tuo piano',
    features_section_title: 'Include:',
    account_tier_card_description_1:
      'Perfetto per chi inizia: gestione gratuita di appuntamenti e pazienti per lanciare la propria carriera.',
    account_tier_card_description_2:
      'Potenzia la tua attività con più appuntamenti, pazienti e sedi illimitate. Investi nel successo professionale.',
    account_tier_card_description_3:
      'Eleva il tuo studio a livelli superiori: gestione illimitata per risultati eccezionali e crescita continua.',
    account_tier_card_feature_description_tier_1_feature_1:
      'Fino a 20 appuntamenti /mese',
    account_tier_card_feature_description_tier_2_feature_1:
      'Fino a 100 appuntamenti /mese',
    account_tier_card_feature_description_tier_3_feature_1:
      'Appuntamenti illimitati',
    account_tier_card_feature_description_tier_1_feature_2:
      'Fino a 50 appuntamenti in programma',
    account_tier_card_feature_description_tier_2_feature_2:
      'Fino a 250 appuntamenti in programma',
    account_tier_card_feature_description_tier_3_feature_2:
      'Programmazione appuntamenti illimitata',
    account_tier_card_feature_description_tier_1_feature_3:
      'Fino a 50 pazienti in rubrica',
    account_tier_card_feature_description_tier_2_feature_3:
      'Rubrica pazienti illimitata',
    account_tier_card_feature_description_tier_3_feature_3:
      'Rubrica pazienti illimitata',
    account_tier_card_feature_description_tier_1_feature_4: '1 sede lavorativa',
    account_tier_card_feature_description_tier_2_feature_4:
      'Sedi lavorive illimitate',
    account_tier_card_feature_description_tier_3_feature_4:
      'Sedi lavorive illimitate',
    account_tier_card_feature_description_tier_1_feature_5:
      'Fino a 3 tipologie di trattamento',
    account_tier_card_feature_description_tier_2_feature_5:
      'Tipologie di trattamento illimitate',
    account_tier_card_feature_description_tier_3_feature_5:
      'Tipologie di trattamento illimitate',
    account_tier_card_feature_description_tier_1_feature_6:
      'Schede anamnestiche, report trattamenti e anagrafica pazienti',
    account_tier_card_feature_description_tier_2_feature_6:
      'Schede anamnestiche, report trattamenti e anagrafica pazienti',
    account_tier_card_feature_description_tier_3_feature_6:
      'Schede anamnestiche, report trattamenti e anagrafica pazienti',
    account_tier_card_feature_description_tier_1_feature_7:
      'Reminder WhatsApp e SMS personalizzabili',
    account_tier_card_feature_description_tier_2_feature_7:
      'Reminder WhatsApp e SMS personalizzabili',
    account_tier_card_feature_description_tier_3_feature_7:
      'Reminder WhatsApp e SMS personalizzabili',
    account_tier_card_feature_description_tier_1_feature_8:
      'Prenotazioni online',
    account_tier_card_feature_description_tier_2_feature_8:
      'Prenotazioni online',
    account_tier_card_feature_description_tier_3_feature_8:
      'Prenotazioni online',
    account_tier_card_feature_description_tier_1_feature_9:
      'Statistiche appuntamenti e pazienti',
    account_tier_card_feature_description_tier_2_feature_9:
      'Statistiche appuntamenti e pazienti',
    account_tier_card_feature_description_tier_3_feature_9:
      'Statistiche appuntamenti e pazienti',
    account_tier_card_feature_description_tier_1_feature_10: 'Chat pazienti',
    account_tier_card_feature_description_tier_2_feature_10: 'Chat pazienti',
    account_tier_card_feature_description_tier_3_feature_10: 'Chat pazienti',
    account_tier_card_feature_description_tier_1_feature_11:
      'Chiusure temporanee',
    account_tier_card_feature_description_tier_2_feature_11:
      'Chiusure temporanee',
    account_tier_card_feature_description_tier_3_feature_11:
      'Chiusure temporanee',
  },
  categories: {
    '8f3ba120-4d8c-4c1e-b627-88fc757f1c64': 'Sport',
    'dabacad0-6a67-4e24-b31f-df13567bacb5': 'Gravidanza',
    '9067e082-a828-4ea5-8276-76029b021cc8': 'Fragili',
    '2145b2b7-7bf2-47d5-928a-292453059b0f': 'Bambini',
    '2700fc13-6e0a-4e25-a216-262d0225f661': 'Riabilitazione',
    '1150faac-63b3-44b2-8fd0-33ce21fc5e96': 'Cuccioli',
    'f880ca79-e0ce-4fbf-b1bb-81c338dcd6b4': 'Traumi',
    'c2751259-cdc5-4214-82d3-29b1e4b3b80c': 'Posturale',
    '0e98b079-6395-46a0-829c-200c1a71a479': 'Benessere',
    '4c9f1da7-d3d4-4765-9834-55f3f6b0529c': 'Biodinamica',
  },
  language: {
    language_name_en: 'Inglese',
    language_name_it: 'Italiano',
  },
  account: {
    modal_input_email_label: 'Email',
    modal_input_timezone_label: 'Fuso orario',
    modal_input_language_label: 'Lingua',
    modal_input_currency_label: 'Valuta',
    modal_input_firstname_label: 'Nome',
    modal_input_lastname_label: 'Cognome',
    button_label_change_password: 'Modifica Password',
    button_label_delete_account: 'Cancella Account',
    button_label_logout_account: 'Esci',
    button_label_save: 'Salva',
    button_label_cancel: 'Annulla',
    validation_error_first_name_required: 'Nome richiesto',
    validation_error_first_name_long: 'Nome troppo lungo',
    validation_error_first_name_short: 'Nome troppo corto',
    validation_error_last_name_required: 'Cognome richiesto',
    validation_error_last_name_long: 'Cognome troppo lungo',
    validation_error_last_name_short: 'Cognome troppo corto',
    page_title_meta: 'Il mio account su {{name}}',
    preferences_section_title: 'Notifiche',
    preferences_not_available_label: 'Non disponibile',
    preferences_email_notification_switch_label:
      'Notifiche email (messaggi, appuntamenti, etc)',
    preferences_push_notification_switch_label:
      'Notifiche push (messaggi, appuntamenti, etc)',
    confirm_profile_image_delete: 'Vuoi eliminare la tua foto profilo?',
    confirm_profile_image_delete_cancel_label: 'Annulla',
    confirm_profile_image_delete_confirm_label: 'Si, eliminala',
  },
  chat: {
    message_header_new_appointment_banner: 'Nuovo appuntamento con {{name}}',
    message_header_appointment_new_mine:
      'Hai richiesto un nuovo appuntamento con {{name}}',
    message_header_appointment_new_other:
      '{{name}} ha richiesto un nuovo appuntamento',
    message_header_appointment_confirmed_other:
      "{{name}} ha confermato l'appuntamento",
    message_header_appointment_confirmed_mine:
      "Hai confermato l'appuntamento con {{name}}",
    message_header_appointment_canceled_mine:
      "Hai cancellato l'appuntamento con {{name}}",
    message_header_appointment_canceled_other:
      "{{name}} ha cancellato l'appuntamento",
    message_header_appointment_complete_mine:
      "L'appuntamento con {{name}} si è concluso",
    message_header_appointment_complete_other:
      "L'appuntamento con {{name}} si è concluso",
    message_header_appointment_change_request_mine:
      "Hai richiesto di modificare l'appuntamento con {{name}}",
    message_header_appointment_change_request_other:
      "{{name}} ha chiesto di modificare l'appuntamento",
    message_header_appointment_cancel_request_mine:
      "Hai richiesto di annullare l'appuntamento con {{name}}",
    message_header_appointment_cancel_request_other:
      "{{name}} ha chiesto di annullare l'appuntamento",
    message_header_appointment_change_denied_mine:
      "{{name}} non può modificare l'appuntamento",
    message_header_appointment_change_denied_other:
      "Hai rifiutato di moficare l'appuntamento con {{name}}",
    message_header_appointment_new_denied_other:
      "{{name}} non può accettare l'appuntamento",
    message_header_appointment_new_denied_mine:
      "Hai rifiutato l'appuntamento con {{name}}",
    message_header_appointment_cancel_denied_mine:
      "{{name}} non può annullare l'appuntamento",
    message_header_appointment_cancel_denied_other:
      "Hai rifiutato di annullare l'appuntamento con {{name}}",
    message_header_appointment_changed_other:
      "{{name}} ha accettato l'appuntamento",
    message_header_appointment_changed_mine:
      "Hai accettato l'appuntamento con {{name}}",
    button_label_modify_appointment: 'Modifica',
    button_label_confirm_appointment: 'Conferma',
    button_label_abort_appointment: 'Annulla',
    button_label_cancel_appointment: 'Cancella',
    button_label_deny_appointment: 'Rifiuta',
    button_label_accept_appointment: 'Accetta',
    button_label_delete_appointment: 'Cancella appuntamento',
    no_conversation_selected_message: 'Nessuna conversazione selezionata',
    error_getting_messages: 'Non possiamo leggere i messaggi in questo momento',
    last_seen_label: 'Ultimo aggiornamento',
    online_label: 'Online',
    blocked: 'Bloccato',
    blocked_conversation_text: 'Questa conversazione è bloccata',
    send_message_label: 'Invia messaggio',
    send_message_placeholder: 'Invia messaggio...',
    menu_profile_information_label: 'Informazioni profilo',
    menu_enable_notifications_label: 'Attiva notifiche',
    menu_new_appointment_label: 'Nuovo appuntamento',
    menu_block_contact_label: 'Blocca contatto',
    menu_unblock_contact_label: 'Sblocca contatto',
    block_user_dialog_text: 'Vuoi bloccare {{name}}?',
    unblock_user_dialog_text: 'Vuoi sbloccare {{name}}?',
    menu_block_contact_confirm_btn_label: 'Blocca',
    menu_block_contact_cancel_btn_label: 'Annulla',
    menu_unblock_contact_confirm_btn_label: 'Sblocca',
    menu_unblock_contact_cancel_btn_label: 'Annulla',
    push_notification_message_text:
      'Vuoi essere avvisato non appena {{name}} risponde?',
    push_notification_accept_label: 'Si, avvisami',
    push_notification_deny_label: 'Non avvisarmi',
    push_notification_deny_disclaimer_text:
      "Senza la notifica immediata potresti non vedere i messaggi in tempo per l'appuntamento. Vuoi disattivarla?",
    push_notification_deny_disclaimer_cancel_label: 'Annulla',
    push_notification_deny_disclaimer_confirm_label: 'Si, non avvisarmi',
    cancel_new_appointment_disclaimer_text: "Vuoi annullare l'appuntamento?",
    cancel_new_appointment_disclaimer_cancel_label: 'No',
    cancel_new_appointment_disclaimer_confirm_label: 'Si, voglio annullarlo',
    deny_new_appointment_disclaimer_text: "Vuoi rifiutare l'appuntamento?",
    deny_new_appointment_disclaimer_cancel_label: 'No',
    deny_new_appointment_disclaimer_confirm_label: 'Si, voglio rifiutarlo',
    confirm_new_appointment_disclaimer_text: "Vuoi confermare l'appuntamento?",
    confirm_new_appointment_disclaimer_cancel_label: 'No',
    confirm_new_appointment_disclaimer_confirm_label: 'Si, voglio confermarlo',
    request_cancel_appointment_disclaimer_text:
      "Vuoi cancellare l'appuntamento?",
    request_cancel_appointment_disclaimer_cancel_label: 'No',
    request_cancel_appointment_disclaimer_confirm_label:
      'Si, voglio cancellarlo',
  },
  appointment: {
    next_appointments_label: 'Prossimi appuntamenti',
    past_appointments_label: 'Appuntamenti passati',
    pending_appointments_label: 'In attesa di conferma',
    no_appointments_label: 'Nessun appuntamento',
    waiting_for_confirmation_label: 'In attesa di conferma',
    appointment_confirmed_label: 'Appuntamento confermato',
    in_progress_label: 'In corso',
    past_appointment_label: 'Appuntamento concluso',
    appointment_waiting_for_closure_label: 'In attesa di chiusura',
  },
  appointment_details: {
    your_appointment_with: 'Il tuo appuntamento con {{name}}',
    service_duration_label: '{{duration}} minuti',
    new_appointment_button_label: 'Nuovo appuntamento',
    go_to_messages_label: 'Vai ai messaggi',
  },
  partner_inreview: {
    in_review_message:
      "Abbiamo ricevuto la tua richiesta e il tuo profilo è attualmente in fase di revisione. Il nostro team sta lavorando per valutarlo nel più breve tempo possibile. Riceverai un'email non appena la revisione sarà completata. Una volta approvato, il tuo profilo sarà pubblico e potrai accettare prenotazioni online. Grazie per la tua pazienza!",
    continue_button_label: 'Continua',
  },
  dashboard: {
    side_menu_item_label_overview: 'Grafici',
    side_menu_item_label_businesses: 'Sedi',
    side_menu_item_label_hours: 'Disponibilità',
    side_menu_item_label_hours_temp_hours_closing: 'Chiusure temporanee',
    side_menu_item_label_hours_temp_hours_opening: 'Aperture temporanee',
    side_menu_item_label_business_details: 'Dettagli Luogo',
    side_menu_item_label_services: 'Servizi',
    side_menu_item_label_service_details: 'Dettagli Servizio',
    side_menu_item_label_appointments: 'Calendario',
    side_menu_item_label_temp_hours: 'Chiusure temporanee',
    side_menu_item_label_appointment_details: 'Dettagli appuntamento',
    side_menu_item_label_clients: 'Pazienti',
    side_menu_item_label_contact_details: '{{name}}',
    side_menu_item_label_chat: 'Messaggi',
    side_menu_item_label_search: 'Cerca',
    side_menu_item_label_preferences: 'Impostazioni',
    side_menu_item_label_logout: 'Esci',
    side_menu_item_label_feedback: 'Invia Feedback',
    side_menu_item_label_treatment_details: 'Dettagli Trattamento',
    side_menu_item_label_preferences_account: 'Account',
    side_menu_item_label_preferences_profile: 'Pagina Profilo',
    side_menu_item_label_preferences_cancel_reasons: 'Motivi annullamenti',
    side_menu_item_label_preferences_payment_methods: 'Tipi di pagamento',
    welcome_logo_header: '{{name}}',
    welcome_logo_action_label: 'Vai alla Dashboard',
    clients_section: {
      warning_free_limit:
        'Hai raggiunto il limite dei contatti per il tuo piano di abbonamento. Passa al Piano Unlimited per avere contatti illimitati',
      no_contact_found_label: 'Nessun contatto trovato',
      contact_search_input_label: 'Cerca',
    },
    appointments_section: {
      no_appointments_label: 'Nessun appuntamento',
      add_appointments_label: 'Aggiungi appuntamento',
      new_appointment_button_label: 'Nuovo appuntamento',
      change_plan_button_label: 'Passa a Piano Pro',
      change_plan_warning_banner_text:
        'Hai raggiunto il numero massimo di appuntamenti inclusi nel piano gratuito. Passa al Piano Unlimited per continuare a creare appuntamenti senza limiti',
      button_label_more: 'Mostra di più...',
      month_view_popup_label: 'Vista mese',
      week_view_popup_label: 'Vista settimana',
      day_view_popup_label: 'Vista giorno',
      list_view_popup_label: 'Lista appuntamenti',
      today_shortcut: 'Vai a Oggi',
    },
    appointment_details_section: {
      appointment_not_found_notification_text: 'Appuntamento non trovato',
      cancel_appointment_dialog_text:
        "Vuoi cancellare l'appuntamento con {{name}}?",
      cancel_appointment_confirm_btn_label: 'Si, cancellalo',
      cancel_appointment_cancel_btn_label: 'Annulla',
      appointment_canceled_notification_text: 'Appuntamento cancellato',
      appointment_cancel_error_notification_text:
        'Impossibile cancellare appuntamento',
      appointment_confirmed_notification_text: 'Appuntamento confermato',
      appointment_confirm_error_notification_text:
        'Impossibile confermato appuntamento',
      warning_schedule_conflict_text:
        'Questo appuntamento si sovrappone ad altri appuntamenti nel tuo calendario',
      cancel_new_appointment_disclaimer_text: "Vuoi annullare l'appuntamento?",
      cancel_new_appointment_disclaimer_cancel_label: 'No',
      cancel_new_appointment_disclaimer_confirm_label: 'Si, voglio annullarlo',
      deny_new_appointment_disclaimer_text: "Vuoi rifiutare l'appuntamento?",
      deny_new_appointment_disclaimer_cancel_label: 'No',
      deny_new_appointment_disclaimer_confirm_label: 'Si, voglio rifiutarlo',
      confirm_new_appointment_disclaimer_text:
        "Vuoi confermare l'appuntamento?",
      confirm_new_appointment_disclaimer_cancel_label: 'No',
      confirm_new_appointment_disclaimer_confirm_label:
        'Si, voglio confermarlo',
      request_cancel_appointment_disclaimer_text:
        "Vuoi cancellare l'appuntamento?",
      request_cancel_appointment_disclaimer_cancel_label: 'No',
      request_cancel_appointment_disclaimer_confirm_label:
        'Si, voglio cancellarlo',
      button_label_move_appointment: 'Sposta appuntamento',
      button_label_cancel_appointment: 'Cancella appuntamento',
      button_label_confirm_appointment: 'Conferma appuntamento',
      button_label_complete_appointment: 'Completa appuntamento',
      button_label_back: 'Indietro',
      button_label_show_conversation: 'Mostra conversazione',
      notes_section_name: 'Note paziente',
      partner_notes_section_name: 'Le tue note',
      button_label_send_whatsapp_notification: 'Invia promemoria WhatsApp',
      button_label_send_sms_notification: 'Invia promemoria SMS',
      button_label_send_whatsapp_confirmation: 'Invia conferma via WhatsApp',
      button_label_send_sms_confirmation: 'Invia conferma via SMS',
      confirm_send_whatsapp_reminder_disclaimer_text:
        'Inviare promemoria WhatsApp a {{name}}?',
      confirm_send_whatsapp_reminder_disclaimer_cancel_label: 'Cancella',
      confirm_send_whatsapp_reminder_disclaimer_confirm_label: 'Invia',
      confirm_send_sms_reminder_disclaimer_text:
        'Inviare promemoria SMS a {{name}}?',
      confirm_send_sms_reminder_disclaimer_cancel_label: 'Annulla',
      confirm_send_sms_reminder_disclaimer_confirm_label: 'Invia',
      confirm_add_contact_phone_disclaimer_text:
        'Questo contatto non ha un numero di telefono. Vuoi aggiungerlo?',
      confirm_add_contact_phone_disclaimer_cancel_label: 'Annulla',
      confirm_add_contact_phone_disclaimer_confirm_label: 'Aggiungi numero',
      confirm_send_whatsapp_confirm_disclaimer_text:
        'Inviare conferma WhatsApp a {{name}}?',
      confirm_send_whatsapp_confirm_disclaimer_cancel_label: 'Cancella',
      confirm_send_whatsapp_confirm_disclaimer_confirm_label: 'Invia',
      confirm_send_sms_confirm_disclaimer_text:
        'Inviare conferma SMS a {{name}}?',
      confirm_send_sms_confirm_disclaimer_cancel_label: 'Annulla',
      confirm_send_sms_confirm_disclaimer_confirm_label: 'Invia',
      button_label_show_contact: 'Mostra contatto',
      button_label_ask_review: 'Richiedi recensione',
      button_label_modify_complete: 'Modifica appuntamento',
      payment_section_label: 'Pagamento',
      report_section_new_report_btn_label: 'Nuova relazione trattamento',
      report_section_view_report_btn_label: 'Mostra relazione trattamento',
      report_section_label: 'Relazione trattamento',
      report_section_no_report_label: 'Nessuna relazione',
      status_section_label_0: 'Stato appuntamento sconosciuto: 0',
      status_section_label_1: 'Nuovo appuntamento in attesa di conferma',
      status_section_label_2: 'Appuntamento confermato',
      status_section_label_3: 'Stato appuntamento sconosciuto: 3',
      status_section_label_4: 'Stato appuntamento sconosciuto: 4',
      status_section_label_5: 'Stato appuntamento sconosciuto: 5',
      status_section_label_6: 'Stato appuntamento sconosciuto: 6',
      status_section_label_7: 'Stato appuntamento sconosciuto: 7',
      status_section_label_8: 'Stato appuntamento sconosciuto: 8',
      status_section_label_9: 'Appuntamento completato',
      status_section_label_10: 'Appuntamento cancellato',
      status_section_label_11: 'Stato appuntamento sconosciuto: 11',
      status_section_label_12: 'Appuntamento spostato',
      notification_report_creation_failure_message: 'Impossibile creare report',
      confirm_new_report_create: 'Vuoi creare una nuova relazione?',
      confirm_new_report_create_cancel_label: 'Annulla',
      confirm_new_report_create_confirm_label: 'Crea',
    },
    complete_appointment: {
      modal_title: 'Completa appuntamento',
      modal_modify_title: 'Modifica appuntamento',
      modal_submit_btn_label: 'Continua',
      modal_step_payment_heading_title: 'Informazioni sul pagamento',
      modal_step_payment_heading_subtitle:
        'Inserisci totale e metodo di pagamento utilizzato',
      modal_step_success_heading_title: 'Appuntamento completato con successo!',
      modal_step_success_heading_subtitle:
        'Puoi richiedere una recensione o fissare subito un nuovo appuntamento con il paziente',
      button_label_ask_review: 'Chiedi recensione',
      button_label_next_appointment: 'Nuovo appuntamento',
      button_label_close: 'Chiudi',
      appointment_complete_notification_text: 'Appuntamento completato!',
      appointment_complete_error_notification_text:
        'Impossibile completare appuntamento',
      modal_step_payment_notes_placeholder: 'Aggiungi note',
      amount_label: 'Totale',
    },
    contacts_section: {
      button_label_new_contact: 'Nuovo contatto',
    },
    page_details_section: {
      button_label_save: 'Salva',
      button_label_cancel: 'Annulla',
    },
    anamnesi: {
      generic_label_notes: 'Note',
      contact_anamnesi_section_label: 'Anamnesi',
      contact_anamnesi_section_sublabel: 'Ultimo aggiornamento: {{updated}}',
      anamnesi_section_field_labels: {
        'fc98021d-2126-4e28-a1f3-f660792a6577': 'Motivo della consultazione',
        '437070ba-76c4-4d54-ac97-ecbec91a159b':
          'Data e circostanze di inizio della sintomatologia',
        'c4d08b73-a5c7-4188-9cac-0ae9ca1d660e': 'Descrizione del dolore',
        '1a557502-c069-4ea3-af9a-50d8660f8556': 'Fattori allevianti',
        '9409d462-762d-4a66-9400-6a167a54a534': 'Fattori peggiorativi',
        'e5b1e666-37d4-4060-965c-c0796231b419': 'Indagini eseguite',
        '9caa19b6-8471-4e16-8d8d-786e151a9d0b':
          'Trattamenti eseguiti e con quale risposta',
        '7dfac186-ac96-4de6-8ca6-0117ec080382': 'Disturbi riscontrati',
        'ea6586aa-e12a-481b-8989-4afdbb0b8c9c': 'Traumi pregressi',
        'd056c8c3-d98f-40c0-8173-1fdb48d4b50e': 'Interventi chirurgici',
        'e122ddba-034b-48fa-b929-0927cbfe240c': 'Allergie',
        '93d43b10-7ef0-43b1-aad8-3dd46fd176c6': 'Abitudini di vita e sport',
        '033f388a-f9a8-4f0a-9a00-be245629507e':
          'Sfera fisica (energia/stanchezza, quantità/qualità del sonno)',
        'a1d88e60-0ec3-4bf7-9055-cae213fca7cf':
          'Sfera psichica (ansia/depressione, ciclotimia, metereopatia)',
        '8848bcbb-4dce-4ce9-ab42-057aa05d1e30':
          'Farmaci utilizzati regolarmente',
        'a94a543a-9403-4642-87b8-9dbba2909be5':
          'Farmaci utilizzati saltuariamente',
        'e8f3ceb1-4dbc-4aba-9fd8-75655cc59d5d': 'Disturbi riscontrati',
        'bb26aaf5-f745-48f8-95fc-45c762d0fe79': 'Scala dolore',
      },
      anamnesi_section_group_labels: {
        '59158e6c-127a-4b22-a21f-2182f1a5f483': 'Dolore riscontrato',
        '16bff906-752d-4851-b45d-4c0d11855db0': 'Stato medico del paziente',
        '47870f40-9898-4e9a-9cdd-c7b8781b24f7': 'Stato generale del paziente',
        'd1dcf5a6-b10e-4d8d-b726-5535606cfac5': 'Farmaci utilizzati',
      },
      anamnesi_section_field_option_labels: {
        'a424c5c1-75e8-4978-9693-5a4839600053': 'Respiratori/ORL',
        'c65fca4b-9fc9-4055-948c-cd7d722d8970': 'Gastro-enterologici',
        '763330a2-223a-431c-a6e1-27c0d5d6a35d': 'Endocrini',
        'c1c0062e-9a26-4530-b6ab-af335d9850c8': 'Ginecologici',
        '9467a126-16bb-41e2-bc0a-2ce67218d62a': 'Urologici',
        '06f3adfb-686b-4668-9a08-508ab5b9bc39': 'Neurologici',
        'f2d8c53e-3b63-438d-b9f8-452c86de89db': 'Metabolici',
        'b845e6b5-2749-4873-8d23-e0082e7d1d2e': 'Cardio-circolatori',
        '6a54a22c-4273-4f8d-9bc5-2daf467ee33a': 'Oculistici',
        '87d44367-d692-4d61-99c3-67dcaa046d40': 'Odontostomatologici',
        '0f39d460-1d1e-444b-822d-a43afde47134': 'Altro',
        'c9b366a3-5851-41c9-a273-490db54b9ea3': 'Nessun dolore',
        'c7e67eff-f8e2-4738-b641-02bf1f80ea3c': 'Dolore lieve',
        '0a14481e-29e4-4ff0-b55c-754652fb070e': 'Dolore moderato',
        '6db002aa-f19e-4605-bf6b-2df07a8fd3c9': 'Dolore severo',
        '54d42b90-afb0-4166-a981-b3271098592e': 'Dolore molto severo',
        '063d010d-b26f-46fb-b4cb-2ebc388b15a7': 'Dolore peggiore possibile',
      },
    },
    contact_details_section: {
      section_sublabel: 'Ultimo aggiornamento: {{updated}}',
      summary_contact_age_label: 'Paziente da',
      summary_contact_previous_appointment_label: 'Ultimo appuntamento',
      summary_contact_total_revenues_label: 'Totale fatturato',
      summary_contact_total_appointments_label: 'Appuntamenti completati',
      summary_contact_reliability_label: 'Affidabilità',
      summary_contact_profile_progress_label: 'Profilo completo',
      charts_section: 'Statistiche',
      contact_basic_section_label: 'Informazioni anagrafiche',
      first_name_label: 'Nome',
      last_name_label: 'Cognome',
      email_label: 'Email',
      phone_label: 'Telefono',
      gender_label: 'Genere',
      notes_label: 'Note',
      gender_option_label_0: 'Maschio',
      gender_option_label_1: 'Femmina',
      gender_option_label_2: 'Non specificato',
      age_label: 'Età',
      age_value_years: '{{years}} anni',
      age_value_months: '{{months}} mesi',
      age_value_days: '{{days}} giorni',
      birth_label: 'Data di nascita',
      ssn_label: 'Codice fiscale',
      occupation_label: 'Attività lavorativa',
      general_practitioner_label: 'Medico curante',
      button_label_back: 'Indietro',
      button_label_modify: 'Modifica contatto',
      button_label_delete: 'Elimina contatto',
      button_label_cancel: 'Annulla',
      button_label_save: 'Salva',
      button_label_messages: 'Vai ai Messaggi',
      button_label_whatsapp: 'Apri chat WhatsApp',
      button_label_block: 'Blocca contatto',
      button_label_unblock: 'Sblocca contatto',
      validation_error_phone: 'Numero di telefono non valido',
      validation_error_email: 'Email non valida',
      validation_error_first_name_required: 'Nome richiesto',
      validation_error_first_name_long: 'Nome troppo lungo',
      validation_error_first_name_short: 'Nome troppo corto',
      validation_error_last_name_required: 'Cognome richiesto',
      validation_error_last_name_long: 'Cognome troppo lungo',
      validation_error_last_name_short: 'Cognome troppo corto',
      send_email_dialog_text: "Vuoi scrivere un'email a {{name}}?",
      send_email_confirm_btn_label: 'Conferma',
      send_email_cancel_btn_label: 'Annulla',
      call_phone_dialog_text: 'Vuoi chiamare {{name}}?',
      call_phone_confirm_btn_label: 'Conferma',
      call_phone_cancel_btn_label: 'Annulla',
      delete_contact_dialog_text: 'Vuoi eliminare il contatto di {{name}}?',
      delete_contact_confirm_btn_label: 'Si, cancellalo',
      delete_contact_cancel_btn_label: 'Annulla',
      notification_message_contact_deleted: 'Contatto cancellato',
      notification_message_contact_delete_error:
        'Impossibile cancellare contatto',
      notification_message_contact_updated: 'Contatto aggiornato',
      notification_message_contact_update_error:
        'Impossibile aggiornare contatto',
      notification_message_contact_blocked: 'Contatto bloccato',
      notification_message_contact_block_error: 'Impossibile bloccare contatto',
      notification_message_contact_unblocked: 'Contatto sbloccato',
      notification_message_contact_unblock_error:
        'Impossibile sbloccare contatto',
      block_user_dialog_text: 'Vuoi bloccare {{name}}?',
      unblock_user_dialog_text: 'Vuoi sbloccare {{name}}?',
      menu_block_contact_confirm_btn_label: 'Blocca',
      menu_block_contact_cancel_btn_label: 'Annulla',
      menu_unblock_contact_confirm_btn_label: 'Sblocca',
      menu_unblock_contact_cancel_btn_label: 'Annulla',
      summary_contact_reliability_value_0: '-',
      summary_contact_reliability_value_1: 'Bassa',
      summary_contact_reliability_value_2: 'Media',
      summary_contact_reliability_value_3: 'Alta',
      summary_contact_reliability_value_4: 'Massima',
      appointment_history: {
        notification_retrieve_data_failure:
          'Impossibile leggere storico appuntamenti',
        section_label: 'Storico appuntamenti',
        table_column_a: 'Data',
        table_column_b: 'Servizio',
        table_column_c: 'Guadagnato',
        table_column_d: 'Stato',
        table_column_e: 'Relazione',
        table_no_results: 'Nessun risultato',
        table_previous_btn_label: 'Precedente',
        table_next_btn_label: 'Successivo',
        appointment_status_0: 'Sconosciuto',
        appointment_status_10: 'Cancellato',
        appointment_status_2: 'Confermato',
        appointment_status_9: 'Completato',
        appointment_status_12: 'Spostato',
      },
      treatment_history: {
        notification_retrieve_data_failure:
          'Impossibile leggere storico appuntamenti',
        section_label: 'Report Trattamenti',
        table_column_a: 'Data',
        table_column_b: 'Servizio',
        table_column_c: 'Guadagnato',
        table_column_d: 'Stato',
        table_column_e: 'Relazione',
        table_no_results: 'Nessun risultato',
        table_previous_btn_label: 'Precedente',
        table_next_btn_label: 'Successivo',
      },
      chart_info_description_appointments:
        'Il grafico a torta rappresenta la distribuzione totale degli appuntamenti di un paziente, suddividendo visivamente le percentuali di appuntamenti completati, cancellati e spostati. Ogni sezione del grafico è colorata in modo distinto per facilitare l’interpretazione rapida dei dati. Questo grafico aiuta a comprendere le abitudini del paziente, evidenziando la frequenza con cui conferma, annulla o modifica gli appuntamenti. È uno strumento utile per valutare l’affidabilità e l’aderenza del paziente al piano di trattamento.',
      chart_info_description_appointment_week_distribution:
        "Il grafico a barre impilate mostra la distribuzione settimanale delle preferenze di appuntamento dei pazienti. Sull'asse delle ascisse sono rappresentati i giorni della settimana, mentre sull'asse delle ordinate si trova il numero di appuntamenti, suddiviso in tre categorie: Completati, Cancellati e Spostati. Ogni barra rappresenta un giorno specifico, con ciascuna sezione della barra colorata per indicare una delle tre categorie. Le barre consentono di confrontare visivamente la quantità di appuntamenti completati, cancellati e spostati per ogni giorno della settimana. Questo tipo di grafico aiuta a identificare i giorni con maggiori o minori cancellazioni o spostamenti, permettendo un'analisi accurata delle tendenze settimanali.",
      chart_info_description_appointment_day_distribution:
        "Il grafico a barre impilate mostra la preferenza oraria di un paziente nella scelta dell’orario dell’appuntamento durante la giornata. Sull'asse delle ascisse sono rappresentate le ore, mentre sull'asse delle ordinate sono indicate le quantità di appuntamenti suddivisi in tre categorie: Completati, Cancellati e Spostati. Ogni ora è rappresentata da una barra composta da sezioni colorate, che indicano le diverse tipologie di appuntamento. Questo grafico permette di osservare in quale fascia oraria si concentrano maggiormente gli appuntamenti completati, cancellati o spostati, fornendo un’indicazione utile per ottimizzare la gestione delle agende e identificare eventuali orari problematici per il paziente.",
    },
    services_section: {
      no_service_found_label: 'Nessun servizio trovato',
      service_search_input_label: 'Cerca',
      modal_title: 'Nuovo Servizio',
      modal_submit_btn_label: 'Crea Servizio',
      modal_step_service_heading_title: 'Nuovo Servizio',
      modal_step_service_heading_subtitle:
        'Inserisci i dati del nuovo servizio',
      validation_step_service_error_name_required: 'Nome richiesto',
      validation_step_service_error_name_short: 'Nome troppo corto',
      validation_step_service_error_name_long: 'Nome troppo lungo',
      validation_step_service_error_description_required:
        'Descrizione richiesta',
      validation_step_service_error_description_short:
        'Descrizione troppo corta',
      validation_step_service_error_description_long:
        'Descrizione troppo lunga',
      validation_step_service_error_duration_required: 'Durata richiesta',
      validation_step_service_error_duration_number:
        'La durata deve essere un numero',
      validation_step_service_error_duration_minimum:
        'La durata minima è {minutes} minuti',
      validation_step_service_error_price_required: 'Prezzo richiesto',
      validation_step_service_error_price_number:
        'Il prezzo deve essere un numero',
      validation_step_service_error_price_positive: 'Prezzo non valido',
      modal_step_service_label_name: 'Nome servizio',
      modal_step_service_label_description: 'Descrizione servizio',
      modal_step_service_label_duration: 'Durata (minuti)',
      modal_step_service_label_price: 'Prezzo',
      modal_step_service_placeholder_name: 'Primo appuntamento',
      modal_step_service_placeholder_description:
        'Il primo passo per una vita più sana',
      notification_success_message: 'Servizio creato con successo',
      notification_failure_message: 'Errore creazione servizio',
      warning_free_limit:
        'Hai raggiunto il limite dei servizi per il tuo piano di abbonamento. Passa al Piano Pro per avere servizi illimitati',
    },
    profile_details_section: {
      completeness_complete_title_label: 'Checklist Profilo',
      completeness_inprogress_title_label: 'Completa il tuo profilo',
      completeness_step_label_1: 'Titolo professionale',
      completeness_step_label_2: 'Foto profilo',
      completeness_step_label_3: 'Biografia',
      completeness_step_label_4: 'Nome sedi ({{complete}}/{{total}})',
      completeness_step_label_5: 'Orari sedi ({{complete}}/{{total}})',
      completeness_step_label_6: 'Descrizione servizi ({{complete}}/{{total}})',
      bio_label: 'Biografia',
      bio_description_label: 'Aggiungi la tua biografia',
      button_label_save_bio: 'Salva',
      button_label_cancel_bio: 'Annulla',
      no_bio: 'Nessuna biografia',
      button_go_to_public_profile: 'Vai a profilo pubblico',
      button_publish_public_profile: 'Pubblica profilo pubblico',
      button_unpublish_public_profile: 'Nascondi profilo pubblico',
      confirm_profile_image_delete: 'Vuoi eliminare la tua foto profilo?',
      confirm_profile_image_delete_cancel_label: 'Annulla',
      confirm_profile_image_delete_confirm_label: 'Si, eliminala',
      confirm_unpublish_text: 'Vuoi nascondere il tuo profilo pubblico?',
      confirm_unpublish_cancel_label: 'Annulla',
      confirm_unpublish_confirm_label: 'Si, nascondilo',
      confirm_publish_text: 'Vuoi pubblicare il tuo profilo pubblico?',
      confirm_publish_cancel_label: 'Annulla',
      confirm_publish_confirm_label: 'Si, pubblicalo',
      notification_unpublish_profile_success: 'Profilo nascosto',
      notification_unpublish_profile_failure: 'Impossibile nascondere profilo',
      notification_publish_profile_success: 'Profilo pubblicato',
      notification_publish_profile_failure: 'Impossibile pubblicare profilo',
    },
    treatment_section: {
      section_label: 'Trattamento',
      button_label_save: 'Salva',
      button_label_cancel: 'Annulla',
      section_sublabel: 'Ultimo aggiornamento: {{updated}}',
      treatment_section_group_labels: {
        '0dd670f7-bd31-4616-961e-b01b437837c3': 'Dettagli',
      },
      treatment_section_field_labels: {
        '070e02ef-ec35-46c2-bc04-fbcd878d7747': 'Data',
        '4e085fa2-2a38-499d-a5b7-2d324801311c': 'Motivo del trattamento',
        '4c101830-ee17-40eb-8ade-f7ac8bb9f85a': 'Stato del paziente',
        'c9c2f465-78c6-44c0-a17d-9d24178d017a': 'Descrizione del trattamento',
        '4e6bd817-8454-4f0e-b107-30b4777a8918': 'Note',
      },
      treatment_section_field_option_labels: {
        '01b2101b-94e9-4eb0-93eb-25ea5b86ca10': 'Data',
        'f8f7f49f-c3b0-421b-ad4d-7db21c0625ac': 'Motivo del trattamento',
        '99eca4a5-a697-4e51-8235-6f2dd81466b5': 'Stato del paziente',
        '2f2594d2-c5d3-438d-a25e-6ff116682fd1': 'Descrizione del trattamento',
        '64b0fcd5-1c03-407b-89da-e08cdc4c0afb': 'Note',
      },
    },
    service_details_section: {
      button_label_back: 'Indietro',
      button_label_modify: 'Modifica servizio',
      button_label_delete: 'Elimina servizio',
      button_label_disable: 'Nascondi servizio',
      button_label_enable: 'Pubblica servizio',
      button_label_save: 'Salva',
      button_label_cancel: 'Annulla',
      name_label: 'Nome',
      duration_label: 'Durata',
      service_duration_label: '{{duration}} minuti',
      price_label: 'Prezzo',
      description_label: 'Descrizione',
      categories_label: 'Categoria',
      tags_label: 'Categoria',
      businesses_label: 'Sedi',
      no_businesses_label: 'Il servizio non è associato a nessuna sede',
      delete_service_dialog_text: 'Vuoi eliminare {{name}}?',
      delete_service_cancel_btn_label: 'Annulla',
      delete_service_confirm_btn_label: 'Si, eliminalo',
      service_deleted_notification_text: 'Servizio eliminato',
      service_delete_error_notification_text: 'Impossibile eliminare servizio',
      disable_service_dialog_text: 'Vuoi nascondere {{name}}?',
      disable_service_cancel_btn_label: 'Annulla',
      disable_service_confirm_btn_label: 'Si, nascondi',
      service_disabled_notification_text: 'Servizio nascosto',
      service_disable_error_notification_text:
        'Impossibile nascondere servizio',
      enable_service_dialog_text: 'Vuoi pubblicare {{name}}?',
      enable_service_cancel_btn_label: 'Annulla',
      enable_service_confirm_btn_label: 'Si, pubblica',
      service_enabled_notification_text: 'Servizio pubblicato',
      service_enable_error_notification_text: 'Impossibile pubblicare servizio',
      validation_step_service_error_name_required: 'Nome richiesto',
      validation_step_service_error_name_short: 'Nome troppo corto',
      validation_step_service_error_name_long: 'Nome troppo lungo',
      validation_step_service_error_description_required:
        'Descrizione richiesta',
      validation_step_service_error_description_short:
        'Descrizione troppo corta',
      validation_step_service_error_description_long:
        'Descrizione troppo lunga',
      validation_step_service_error_duration_required: 'Durata richiesta',
      validation_step_service_error_duration_number:
        'La durata deve essere un numero',
      validation_step_service_error_duration_minimum:
        'La durata minima è {minutes} minuti',
      validation_step_service_error_price_required: 'Prezzo richiesto',
      validation_step_service_error_price_number:
        'Il prezzo deve essere un numero',
      validation_step_service_error_price_positive: 'Prezzo non valido',
      service_updated_notification_text: 'Servizio aggiornato',
      service_update_error_notification_text: 'Impossibile aggiornare servizio',
      service_switched_active_notification_text: 'Servizio attivato',
      service_switch_active_error_notification_text:
        'Impossibile attivare servizio',
      service_switched_inactive_notification_text: 'Servizio nascosto',
      service_switch_inactive_error_notification_text:
        'Impossibile nascondere servizio',
    },
    businesses_section: {
      no_business_found_label: 'Nessun luogo trovato',
      business_search_input_label: 'Cerca',
      modal_title: 'Nuovo Luogo',
      modal_submit_btn_label: 'Crea Luogo',
      modal_step_location_heading_title: 'Dove svolgi la tua attività?',
      modal_step_location_heading_subtitle: 'Aiuta gli altri a trovarti!',
      modal_next_btn_label: 'Avanti',
      modal_back_btn_label: 'Indietro',
      modal_create_btn_label: 'Crea',
      notification_success_message: 'Luogo creato con successo',
      notification_failure_message: 'Errore creazione luogo',
      warning_free_limit:
        'Hai raggiunto il limite delle sedi per il tuo piano di abbonamento. Passa al Piano Pro per avere sedi illimitate',
    },
    business_details_section: {
      button_label_back: 'Indietro',
      button_label_modify: 'Modifica luogo',
      button_label_delete: 'Elimina luogo',
      button_label_disable: 'Nascondi luogo',
      button_label_enable: 'Mostra luogo',
      button_label_save: 'Salva',
      button_label_cancel: 'Annulla',
      name_label: 'Nome',
      address_label: 'Indirizzo',
      description_label: 'Descrizione',
      hours_label: 'Orari',
      services_label: 'Servizi',
      delete_business_dialog_text: 'Vuoi eliminare {{name}}?',
      delete_business_cancel_btn_label: 'Annulla',
      delete_business_confirm_btn_label: 'Si, eliminalo',
      business_deleted_notification_text: 'Luogo eliminato',
      business_delete_error_notification_text: 'Impossibile eliminare luogo',
      disable_business_dialog_text: 'Vuoi nascondere {{name}}?',
      disable_business_cancel_btn_label: 'Annulla',
      disable_business_confirm_btn_label: 'Si, nascondi',
      business_disabled_notification_text: 'Luogo nascosto',
      business_disable_error_notification_text: 'Impossibile nascondere luogo',
      enable_business_dialog_text: 'Vuoi pubblicare {{name}}?',
      enable_business_cancel_btn_label: 'Annulla',
      enable_business_confirm_btn_label: 'Si, pubblica',
      business_enabled_notification_text: 'Luogo pubblicato',
      business_enable_error_notification_text: 'Impossibile pubblicare luogo',
      business_switched_active_notification_text: 'Luogo attivato',
      business_switch_active_error_notification_text:
        'Impossibile attivare luogo',
      business_switched_inactive_notification_text: 'Luogo nascosto',
      business_switch_inactive_error_notification_text:
        'Impossibile nascondere luogo',
      validation_step_service_error_name_required: 'Nome richiesto',
      validation_step_service_error_name_short: 'Nome troppo corto',
      validation_step_service_error_name_long: 'Nome troppo lungo',
      validation_step_service_error_description_required:
        'Descrizione richiesta',
      validation_step_service_error_description_short:
        'Descrizione troppo corta',
      validation_step_service_error_description_long:
        'Descrizione troppo lunga',
      business_updated_notification_text: 'Luogo aggiornato',
      business_update_error_notification_text: 'Impossibile aggiornare luogo',
      no_services_label: 'Il luogo non è associato a nessun servizio',
    },
    temp_hours_section: {
      closing_hour_label: 'Chiuso',
      opening_hour_label: 'Aperto',
      add_temp_hour_btn_label: 'Aggiungi chiusura temporanea',
      active_section_title: 'Chiusure temporanee attive',
      future_section_title: 'Prossime chiusure temporanee',
      modal_step_new_temp_hour_heading_title: 'Seleziona giorno',
      confirm_delete_temp_hour_text: 'Vuoi eliminare questo orario?',
      confirm_delete_temp_hour_cancel_label: 'Annulla',
      confirm_delete_temp_hour_confirm_label: 'Si, elimina',
      modal_title: 'Nuova chiusura temporanea',
      modal_submit_btn_label: 'Salva',
      modal_cancel_btn_label: 'Chiudi',
      modal_next_btn_label: 'Avanti',
      modal_back_btn_label: 'Indietro',
      modal_skip_btn_label: 'Salta',
      modal_step_type_heading_title:
        'Che tipo di orario temporaneo vuoi aggiungere?',
      modal_step_type_heading_subtitle:
        'Seleziona il tipo di orario temporaneo da creare',
      new_temp_hour_closing_hour_label: 'Chiusura temporanea',
      new_temp_hour_opening_hour_label: 'Apertura temporanea',
      modal_step_period_start_heading_title:
        "Quando inizia l'orario temporaneo?",
      modal_step_period_start_heading_subtitle:
        'Inserisci data e orario di inizio',
      modal_step_period_start_select_time_title: 'Seleziona orario',
      modal_step_period_end_heading_title:
        "Quando finisce l'orario temporaneo?",
      modal_step_period_end_heading_subtitle: 'Inserisci data e orario di fine',
      modal_step_period_end_select_time_title: 'Seleziona orario',
      notes_placeholder: 'Aggiungi note',
      summary_temp_hour_type_label: 'Tipo',
      summary_temp_hour_start_time_label: 'Inizio',
      summary_temp_hour_end_time_label: 'Fine',
      summary_temp_hour_notes_label: 'Note',
      summary_temp_hour_businesses_label: 'Sedi',
      summary_temp_hour_services_label: 'Servizi',
      modal_step_business_selection_heading_title:
        'A quali sedi vuoi applicarlo?',
      modal_step_business_selection_heading_subtitle:
        "Seleziona dove vuoi che l'orario temporaneo abbia effetto",
      modal_step_service_selection_heading_title:
        'A quali servizi vuoi applicarlo?',
      modal_step_service_selection_heading_subtitle:
        "Seleziona su quali servizi vuoi che l'orario temporaneo abbia effetto",
      modal_step_business_selection_applies_to_all: 'Tutti le sedi',
      modal_step_business_selection_applies_to_selection: 'Sedi selezionate',
      modal_step_service_selection_applies_to_all: 'Tutti i servizi',
      modal_step_service_selection_applies_to_selection: 'Servizi selezionati',
      no_active_hours_found_label: 'Nessun orario temporaneo attivo',
      no_future_hours_found_label: 'Nessun orario temporaneo in programma',
      delete_success_message: 'Orario cancellato',
      delete_failure_message: 'Impossibile cancellare orario',
      create_success_message: 'Orario creato',
      create_failure_message: 'Impossibile creare orario',
      temp_hour_text_template_closed_interval: 'Da {{starts}} fino a {{ends}}',
      temp_hour_text_template_open_interval: 'Da {{starts}}',
      temp_hour_text_template_businesses_label: 'Sedi:',
      temp_hour_text_template_services_label: 'Servizi:',
      temp_hour_text_template_notes_label: 'Note:',
    },
    charts_section: {
      total_clients_summary_title_label: 'Pazienti Trattati',
      total_clients_summary_default_period_label: 'Ultimi 12 mesi',
      total_clients_summary_previous_period_label:
        'Mese precedente: {{amount}}',
      total_appointments_summary_title_label: 'Appuntamenti',
      total_appointments_summary_default_period_label: 'Questo mese',
      total_appointments_summary_previous_period_label:
        'Mese precedente: {{amount}}',
      total_revenues_summary_title_label: 'Totale Incassi',
      total_revenues_summary_default_period_label: 'Questo mese',
      total_revenues_summary_previous_period_label:
        'Mese precedente: {{amount}}',
      clients_chart_title_label: 'Nuovi Pazienti',
      clients_chart_default_period_label: 'Ultimi 12 mesi',
      revenues_chart_title_label: 'Entrate',
      revenues_chart_default_period_label: 'Ultimi 12 mesi',
      services_chart_title_label: 'Appuntamenti',
      services_chart_default_period_label: 'Ultimi 12 mesi',
      services_chart_column_group_label_value: 'Completati',
      services_chart_column_group_label_value_b: 'Cancellati',
      services_chart_column_group_label_value_c: 'Spostati',
      services_chart_column_group_tooltip_value: 'Completati: {{amount}}',
      services_chart_column_group_tooltip_value_b: 'Cancellati: {{amount}}',
      services_chart_column_group_tooltip_value_c: 'Spostati: {{amount}}',
      profile_chart_title_label: 'Visualizzazioni profilo',
      profile_chart_default_period_label: 'Ultimi 30 giorni',
      contact_appointments_week_distribution_chart_title: 'Giorni preferiti',
      contact_appointments_hour_distribution_chart_title: 'Orari preferiti',
      contact_appointments_pie_chart_title: 'Appuntamenti',
      contact_appointments_week_distribution_chart_column_group_label_completed:
        'Completati',
      contact_appointments_week_distribution_chart_column_group_label_canceled:
        'Cancellati',
      contact_appointments_week_distribution_chart_column_group_label_moved:
        'Spostati',
      contact_appointments_hour_distribution_chart_column_group_label_completed:
        'Completati',
      contact_appointments_hour_distribution_chart_column_group_label_canceled:
        'Cancellati',
      contact_appointments_hour_distribution_chart_column_group_label_moved:
        'Spostati',
      contact_appointments_pie_chart_column_group_label_completed: 'Completati',
      contact_appointments_pie_chart_column_group_label_canceled: 'Cancellati',
      contact_appointments_pie_chart_column_group_label_moved: 'Spostati',
      contact_appointments_week_distribution_chart_column_group_tooltip_value:
        'Completati: {{amount}}',
      contact_appointments_week_distribution_chart_column_group_tooltip_value_b:
        'Cancellati: {{amount}}',
      contact_appointments_week_distribution_chart_column_group_tooltip_value_c:
        'Spostati: {{amount}}',
      contact_appointments_hour_distribution_chart_column_group_tooltip_value:
        'Completati: {{amount}}',
      contact_appointments_hour_distribution_chart_column_group_tooltip_value_b:
        'Cancellati: {{amount}}',
      contact_appointments_hour_distribution_chart_column_group_tooltip_value_c:
        'Spostati: {{amount}}',
      balance_chart_info_description:
        "Il grafico mostra l'andamento delle entrate negli ultimi 12 mesi. L’asse orizzontale rappresenta i mesi, mentre l’asse verticale indica il valore delle entrate in unità monetarie. Complessivamente, il grafico suggerisce una crescita/decrescita/stabilità delle entrate nel periodo analizzato.",
      profile_chart_info_description:
        'Il grafico mostra l’andamento delle visualizzazioni della pagina profilo negli ultimi 30 giorni. L’asse orizzontale rappresenta i giorni, mentre l’asse verticale indica il numero di visualizzazioni. Complessivamente, il grafico suggerisce una crescita/decrescita/stabilità nell’interesse per il profilo nel periodo analizzato.',
      clients_chart_info_description:
        'Il grafico a barre mostra il numero di nuovi pazienti acquisiti ogni mese negli ultimi 12 mesi. L’asse orizzontale rappresenta i mesi, mentre l’asse verticale indica la quantità di nuovi pazienti. Ogni barra riflette il numero di nuovi pazienti per il mese corrispondente. Il grafico evidenzia una crescita/decrescita/andamento stabile nel tempo, offrendo un quadro chiaro dell’acquisizione di nuovi pazienti nel periodo analizzato.',
      services_chart_info_description:
        "Il grafico a barre mostra la distribuzione mensile degli appuntamenti completati, cancellati e spostati negli ultimi 12 mesi. L’asse orizzontale rappresenta i mesi, mentre l’asse verticale indica il numero di appuntamenti. Ogni mese è suddiviso in tre categorie: completati, cancellati e spostati, ognuna rappresentata da un colore distinto. L'andamento delle barre consente di individuare trend e variazioni nel tempo, come periodi con più appuntamenti completati o un aumento delle cancellazioni in specifici mesi. Questo grafico è utile per analizzare l’efficienza della gestione degli appuntamenti e identificare eventuali pattern stagionali o operativi.",
      balance_summary_info_description:
        "Il widget mostra il totale degli incassi dell'ultimo mese in un valore numerico con valuta, offrendo una panoramica immediata delle entrate più recenti. Sotto il valore principale, è presente un grafico a linea senza assi che rappresenta l’andamento degli incassi negli ultimi 12 mesi, permettendo di visualizzare trend e variazioni. Inoltre, una label evidenzia la variazione percentuale rispetto al mese precedente, indicando se gli incassi sono aumentati o diminuiti. Questo widget fornisce un riepilogo chiaro e immediato della situazione finanziaria, utile per monitorare la crescita o individuare cali di rendimento.",
      services_summary_info_description:
        "Il widget mostra il totale degli appuntamenti completati e confermati nell'ultimo mese come un singolo valore numerico, offrendo una visione immediata dell'attività recente. Sotto il valore principale, un grafico a linea senza assi illustra l’andamento degli appuntamenti negli ultimi 12 mesi, consentendo di individuare tendenze e variazioni. Inoltre, una label evidenzia la differenza percentuale rispetto al mese precedente, indicando se il numero di appuntamenti è aumentato o diminuito. Questo widget fornisce un riepilogo chiaro e utile per monitorare l’efficacia della gestione degli appuntamenti nel tempo.",
      clients_summary_info_description:
        "Il widget mostra il totale dei nuovi pazienti acquisiti negli ultimi 12 mesi come un singolo valore numerico, fornendo un'indicazione chiara della crescita della base di pazienti. Sotto il valore principale, un grafico a linea senza assi rappresenta l’andamento incrementale del totale dei pazienti gestiti negli ultimi 12 mesi, offrendo una panoramica visiva della crescita complessiva. Inoltre, una label evidenzia la variazione percentuale dei nuovi pazienti acquisiti rispetto al mese precedente, permettendo di monitorare facilmente le tendenze. Questo widget aiuta a comprendere l’efficacia delle strategie di acquisizione e fidelizzazione dei pazienti.",
    },
  },
  notifications: {
    appointment_reminder_whatsapp:
      "Ciao {{name}}, ti ricordo l'appuntamento di {{day}} alle {{hour}} per {{service}} presso {{address}}",
    appointment_reminder_sms:
      "Ciao {{name}}, ti ricordo l'appuntamento di {{day}} alle {{hour}} per {{service}} presso {{address}}",
    appointment_confirm_whatsapp:
      "Ciao {{name}}, ti confermo l'appuntamento di {{day}} alle {{hour}} per {{service}} presso {{address}}",
    appointment_confirm_sms:
      "Ciao {{name}}, ti confermo l'appuntamento di {{day}} alle {{hour}} per {{service}} presso {{address}}",
  },
  tags: {
    input_placeholder: 'Categoria',
    search_placeholder: 'Cerca',
    'fc98021d-2126-4e28-a1f3-f660792a6577': 'medico di medicina generale',
    '27011e17-e816-4156-857a-b979802d7fc6': 'ginecologo',
    'a7744666-cf26-47c6-a184-0cf6a45cf18b': 'ortopedico',
    '709c8f17-33c2-409d-af3a-a728700a723d': 'dermatologo',
    '4825b1fe-7aa3-4ada-8ba2-e51246b17b40': 'nutrizionista',
    '453245e5-4042-44e2-83ce-07aec219f30a': 'psicologo',
    '2cb6a5da-3419-414c-8e3e-4a078fb07b8f': 'oftalmologo',
    'cc9949a0-f2b6-4385-b7a6-468d81e6796e': 'urologo',
    'd9e3b950-316b-4793-b303-32a7727acadd': 'otorino',
    'e1be1b28-989f-4c18-8da8-f407c40b6ee6': 'cardiologo',
    '9dd49009-b52f-46de-8fa1-4dae2e267f30': 'dentista',
    '2f2e5617-31fa-41ca-a4ac-332898631be1': 'chirurgo generale',
    '34be340d-a8d8-4e62-86ee-5c951f28aa27': 'osteopata',
    '6b7dbe55-9377-40e1-a6fe-5c0dfa5b19ef': 'internista',
    '8609a0dd-22ae-4d48-9fda-4077e8fefae3': 'medico estetico',
    'df6f7c7a-4d67-4b42-8c3c-6ddac9c13cfa': 'endocrinologo',
    'cf4bb9ee-033b-4ca3-b763-ead769a2d305': 'gastroenterologo',
    '7ac6bced-9786-4e25-a8e9-a13ca2f39afc': 'neurologo',
    '6a3ff33e-92bf-4816-a66a-d9c26bd6d589': 'neurochirurgo',
    'd72e2b5d-54e3-4dfc-9f98-f3fa10596ff1': 'fisioterapista',
    'b1e70abd-ff17-43ae-b225-04dc5b9f65fa': 'chirurgo plastico',
    '579cf9ee-d205-464d-bbbf-b796bb5e4f41': 'psichiatra',
    'db593f2b-7aee-44f4-8274-c3ab11459ebd': 'psicoterapeuta',
    '4ea35462-7693-4b4c-83c3-46f6c110098b': 'pediatra',
    'eb935e4b-307f-4745-a9a6-c23083dd9be1': 'podologo',
    'df6c69ce-69ba-463c-b35d-bce63a5cd401': 'reumatologo',
    'c740313b-1833-40d0-baa7-11bb80350768': 'pneumologo',
    '800127f6-71b4-45e1-a9d8-d0eb4201d2ce': 'fisiatra',
    'b5971770-c370-4491-adbb-ad2e48da4375': 'chiururgo vascolare',
    '164b1292-ab49-4de6-8e02-ae9038a4e3c1': 'dietista',
    '1529048c-2b86-4952-a5a1-2d54affb8378': 'andrologo',
    'dc3b7738-47b2-4dd9-ab6a-d131b78e6563': 'allergologo',
    'd313374b-6fcd-40e6-9d55-8de81d21d6c7': 'radiologo',
    '62dcc7fc-1d0b-410d-b839-704daee8cc7b': 'proctologo',
    '0e98257d-0611-43cd-9bb7-b0aac7f94440': 'angiologo',
    'c06f7c71-a179-4228-9277-bbc5ecfb2937': 'ematologo',
    'c12b1a38-ab03-4ce3-99e9-ff2c4046eac0': 'senologo',
    '78776e61-1431-454b-b1a2-e7de3938d782': 'dietologo',
    '2b03c910-9ddc-4662-adfa-75dead4af6e2': 'geriatra',
    '419afb2f-77f3-437c-83be-1f333025b831': 'medico dello sport',
    'bad22744-6c18-4db4-a15f-2ae2a403490b': 'agopuntore',
    'fabd20be-442a-4f9a-b983-465e283f2ea0': 'oncologo',
    '71ef4a5d-b588-4060-87d8-20166fd132e0': 'pediatra di libera scelta',
    'f8040d12-52d1-44a4-b65e-432c9aebe67a': 'psicologo clinico',
    '3fd32fbb-099d-4120-940e-792f4ee3b8e0': 'chirurgo',
    'a3fda5c9-5668-494e-9a18-1762d9aeea57': 'nefrologo',
    '9457845b-e0c9-48fb-9cdc-c3aa40d913b4': 'diabetologo',
    'ba743591-56f8-41b0-9602-822cd8dff0eb': 'logopedista',
    '97253da4-77e3-4354-ac71-04a51d16fda4': 'chiropratico',
    'cb302c5f-fe00-440e-8afe-d5ca5e5ad48d': 'cardiochirurgo',
    '7d7752d1-daca-4b5c-ac8f-81f8cc0eecb5': 'chirurgo maxillo facciale',
    '681fb012-f374-494e-8a37-4b4469a7207d': 'medico legale',
    '926bf970-3f03-413f-92c4-0b71d70fa1fb': 'ortodontista',
    'd573d25e-a42f-4be3-85f5-7b25605aa233': 'neuropsichiatra infantile',
    '695a9ca0-ac93-40a6-9848-9ceb5e9bbffc': 'chirurgo estetico',
    '919404e9-7505-47a2-867a-7cd8513b4a6e': 'anestesista',
    '7df670ee-cfcc-4721-add4-a1b8ba65376f': 'terapista del dolore',
    '8f580c04-637c-4008-b826-829238447844': 'ostetrica',
    'b44280e2-6831-437d-b585-d71c50b21b66': 'medico competente',
    '40bbeec3-a295-4215-aef0-dd7f59fb32aa': 'omeopata',
    '546edd8d-663f-4383-bf35-96f08ac8ef3e': 'infettivologo',
    '15b82434-ad69-410c-88e2-e80c5ecee21d': 'sessuolog',
    '52cd5554-3a2e-46ca-a2ed-eb2f08c71f8d': 'epatologo',
    'fa3cc123-c2f1-4cce-a226-b93f4c67450d': 'ecografista',
    '0182c98a-ab48-4266-9df7-f1bad76413a3': 'chirurgo toracico',
    '033e2c17-f567-42fe-8190-d9f10e63e739': 'radiologo diagnostico',
    '6bef4f14-cac3-49c6-832e-352d975f3939': 'chirurgo pediatrico',
    'f5d7c768-74f0-4fe9-a21f-7dcc95a76f1c': 'massofisioterapista',
    '698481a4-2cb6-4731-8f85-fbbc0582d264': 'ortottista',
    '199bc0dc-2f84-43a6-b623-5964f2148010': 'chirurgo vertebrale',
    '8e5ad442-edc1-4e4f-aedd-70f6d000669e': 'posturologo',
    'baf7cc2c-5bd2-4096-ad3b-ec8cc816e9c1': 'tecnico sanitario',
    '7f51bf1a-cbd4-4231-855d-ee31047c3ef5': 'terapeuta',
    'f70256ae-5649-4078-9270-7ada891049d3': 'foniatra',
    'cdc312d7-ca96-4db7-9e2a-9b2dff859721': 'tricologo',
    'e3203ddf-e0c2-4c87-90a3-e7eb6d4b9194': 'professional counselor',
    '239d39fe-ed74-4928-a1ae-ae979986fefb': 'immunologo',
    'ab882720-6eaa-4c58-b919-77e085b17161': 'igienista dentale',
    '83020675-9a8a-4cd1-8ce4-76dac907df16': 'medico certificatore',
    '44ccc6ea-23e1-491f-be43-365772ad3965': 'medico genetista',
    '379473b8-ea34-47ba-9eff-34f254192e99': 'neuropsicologo',
    '81fe6ea6-3f83-4014-9033-28ab73f3519d': 'biologo della riproduzione',
    'e8236f95-d4b7-4400-8c45-7581d1c62ee8': 'anatomopatologo',
    '153d6c3b-8339-467a-9df2-101d1e855205': 'radioterapista',
    '832aab8c-8f53-4d11-804a-b1bfa6393625': 'medico nucleare',
    '0fbaf87b-8034-48ab-96e5-4a1c5794bb40': 'infermiere',
    '67505de6-e755-40fa-8495-302b7c05b237': 'chinesiologo',
    '16bb3bac-89c5-40bc-8f3d-73d8ce179304': 'donazione sangue',
    '33458c57-040b-4feb-bb70-466dc06b22ca': 'stomatologo',
    'ed6d2ab6-5460-4dee-97de-66353921ffd4': 'tecnico radiologo',
    'b8cfa3c5-b208-49b0-818a-d5eedac11966': 'analista clinico',
    '20e56c93-efa8-46de-87f2-086714c3108d': 'audioprotesista',
    'bc23b5ec-c8ba-4671-aff2-fe3edbbece3f': 'epidemiologo',
    '3150a19f-e2f7-4629-a3eb-0a50640367fc': 'venereologo',
    'c422cf13-79da-4397-92c6-ee0358eee66d': 'odontotecnico',
  },
  cancel_reason_template: {
    'dc138457-ffc3-41c7-a07a-276c9c2b4df7':
      "Il paziente ha richiesto di cancellare l'appuntamento",
    '8b7bb270-1e52-4be3-8623-befc564cd7bb': 'Il paziente non si è presentato',
    'dba1450b-a4bf-4753-8921-77c60ec085be': 'Aggiunto per errore dal paziente',
    '1f2b387c-28b0-49ab-b2b4-65a6e715df02': 'Altro',
    'd9c61337-b226-47f5-9457-c41dd7c3c3b6': 'Non storicizzare',
  },
  payment_method_template: {
    'a9355e72-b05b-4fea-b19b-ebc05e1677a3': 'Altro',
    'b7543c2a-15c0-434a-8922-a38a0712e19d': 'Non storicizzare',
    '3e5a7ce4-3266-496b-828b-f9c2be20c8c0': 'Carta di credito',
    'dadb749e-8cfc-4b31-9a6f-e6c364ddb196': 'Contanti',
    '2b68f512-ad20-4e2c-b440-855d956a965d': 'Da pagare',
  },
  onclickpage: {
    unsubscribe_success_message_title: 'Ci mancherai',
    unsubscribe_success_message_description:
      'Cancellazione dal sistema di notifiche e-mail di {{name}} eseguita con successo',
    unsubscribe_email_failure_message: 'Impossibile completare la richiesta',
  },
  seo: {
    partner_profile_page_description:
      'Riceve {{cities}} ogni {{open_days}}.{{service}} Prenota ora un appuntamento!',
    cookie_page_title:
      'Cookie Policy | Scopri come utilizziamo i cookie su {{service}}',
    cookie_page_description:
      'Scopri la nostra Cookie Policy: quali cookie utilizziamo, perché li usiamo e come puoi gestire le tue preferenze per garantire una navigazione sicura e personalizzata.',
    privacy_page_title:
      'Privacy Policy | Scopri come proteggiamo i tuoi dati su {{service}}',
    privacy_page_description:
      'Consulta la nostra Privacy Policy per capire come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali nel rispetto della normativa vigente.',
    terms_page_title:
      'Termini di Servizio | Le regole per utilizzare {{service}}',
    terms_page_description:
      'Leggi i nostri Termini di Servizio per conoscere le regole di utilizzo, i diritti e le responsabilità degli utenti su {{service}}.',
  },
};

export default locale;
